import '../css/index.scss';
import 'bootstrap/dist/js/bootstrap.bundle';
import './search';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.js-hamburger').addEventListener('click', () => {
    document.querySelector('.navbar-collapse.collapse').classList.toggle('show');
  });

  // Event apply page
  const urlParams = new URLSearchParams(window.location.search);
  const eventNameInputEl = document.querySelector('[name="event"]');

  eventNameInputEl.parentElement.parentElement.style.display = "none";
  setTimeout(() => {
    if (eventNameInputEl && urlParams.has('qn')) {
      eventNameInputEl.value = urlParams.get('qn');
    }
  }, 5000);

  if (document.querySelector('[data-voting-enabled="1"]')) {
    const votes = localStorage.getItem('WMFK2');
    // alert("voting enabled");
    const els = document.querySelectorAll('.wm-bout-card');
    Array.prototype.forEach.call(els, (el) => {
      const fighterBtn = el.querySelector('[data-bout-vote="fighter"]');
      const oppBtn = el.querySelector('[data-bout-vote="opponent"]');
      const hasVoted = hasVotedForBout(fighterBtn.dataset.id, fighterBtn.dataset.boutNumber);

      if (!hasVoted) {
        fighterBtn.disabled = false;
        oppBtn.disabled = false;

        fighterBtn.addEventListener('click', (e) => {
          oppBtn.disabled = true;
          fighterBtn.disabled = true;
          sendVote(fighterBtn.dataset.boutVote, fighterBtn.dataset.boutNumber, fighterBtn.dataset.id, fighterBtn);
        });

        oppBtn.addEventListener('click', (e) => {
          oppBtn.disabled = true;
          fighterBtn.disabled = true;
          sendVote(oppBtn.dataset.boutVote, oppBtn.dataset.boutNumber, fighterBtn.dataset.id, oppBtn);
        });
      }
    })
  }
});

const hasVotedForBout = (id, boutNumber) => {
  const votes = localStorage.getItem('WMFK2');
  let newVotes = {[id]: []};
  if (votes) {
    newVotes = JSON.parse(votes);
  }
  const oldVotes = [...newVotes[id]];
  return oldVotes.indexOf(boutNumber) !== -1;
}

const sendVote = (whom, boutNumber, id, btnEl) => {
  fetch(`/wp-json/wolfmma-blocks/v1/vote?number=${boutNumber}&who=${whom}&id=${id}`, {
    method: "PUT", // *GET, POST, PUT, DELETE, etc.
  }).then(() => {
    saveVote(id, boutNumber);
    window.location.reload();
  }).catch(() => {
    alert('Something went wrong while voting...')
    btnEl.disabled = false;
  });
}

const saveVote = (id, boutNumber) => {
  const votes = localStorage.getItem('WMFK2');
  let newVotes = {};
  if (votes) {
    newVotes = JSON.parse(votes);
  }

  if (newVotes[id]) {
    const oldVotes = [...newVotes[id]];
    if (oldVotes.indexOf(boutNumber) !== -1) {
      alert("not allowed!");
    }
    newVotes[id] = [...newVotes[id], boutNumber];
  } else {
    newVotes[id] = [boutNumber];
  }

  localStorage.setItem('WMFK2', JSON.stringify(newVotes));
}

jQuery(document).ready(function ($) {
  if (jQuery('.wpcf7-form').length) {
    var astx_label_class = 'form-check-label',
        astx_input_class = 'form-check-input',
        astx_parent_class = 'form-check';

    $('.wpcf7-form input[type=checkbox], .wpcf7-form input[type=radio]').each(function () {
      var element = $(this),
          parent = element.closest('.wpcf7-list-item');
      element.addClass(astx_input_class);
      parent.addClass(astx_parent_class);
      if (astx_label_class)
        parent.find('wpcf7-list-item-label').addClass(astx_label_class);
    });
  }
});
